'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div `
  background-color: ${({ theme }) => theme.colors.body.background};
  border-radius: ${({ theme }) => theme.designTokens.cardRadius};
  box-shadow: ${({ theme }) => theme.designTokens.cardShadow};
  display: inline-block;
  padding: ${({ theme, py }) => theme.space.component.y[py]} ${({ theme, px }) => theme.space.component.x[px]};
`;
const Styled = {
    Container,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
